export const environment = {
  apiUrl: "https://api.hml-checkout.feev.com.br",
  threeDSEnvironment: "SDB",
};
